import { OhVueIcon, addIcons } from "oh-vue-icons";
import {
  MdLogin,
  MdLogout,
  MdSaveOutlined,
  MdEditOutlined,
  MdCheckOutlined,
  MdClose,
  MdAccountcircle,
  MdCameraaltOutlined,
  MdSettingsOutlined,
  MdCheckcircleOutlined,
  MdError,
  MdInfo,
  MdEmailOutlined,
  MdPhoneOutlined,
  MdPindropOutlined,
  MdWorkoutline,
  MdPersonOutlined,
  MdLocationon,
  MdLocationonOutlined,
  MdArrowbackiosnewOutlined,
  MdArrowforwardiosOutlined,
  MdContentcopyOutlined,
  MdBrightnesshighOutlined,
  MdBrightnesslowOutlined,
  MdSyncOutlined,
  MdWarningamberOutlined,
  MdLightmodeOutlined,
  MdNightlightRound,
  MdArrowdropdownOutlined,
  MdPersonpinRound,
  MdNophotography,
  MdRestoreOutlined,
  MdLockOutlined,
} from "oh-vue-icons/icons/md";

addIcons(
  MdLogin,
  MdLogout,
  MdSaveOutlined,
  MdEditOutlined,
  MdCheckOutlined,
  MdClose,
  MdAccountcircle,
  MdCameraaltOutlined,
  MdSettingsOutlined,
  MdCheckcircleOutlined,
  MdError,
  MdInfo,
  MdEmailOutlined,
  MdPhoneOutlined,
  MdPindropOutlined,
  MdWorkoutline,
  MdPersonOutlined,
  MdLocationon,
  MdLocationonOutlined,
  MdArrowbackiosnewOutlined,
  MdArrowforwardiosOutlined,
  MdContentcopyOutlined,
  MdBrightnesshighOutlined,
  MdBrightnesslowOutlined,
  MdSyncOutlined,
  MdWarningamberOutlined,
  MdLightmodeOutlined,
  MdNightlightRound,
  MdArrowdropdownOutlined,
  MdPersonpinRound,
  MdNophotography,
  MdRestoreOutlined,
  MdLockOutlined,
);

export default OhVueIcon;
